import styled from "styled-components";

export const TableContainer = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  overflow: "hidden",
}));

export const Table = styled("table")(({ theme, minWidth, isClickableRow }) => ({
  borderCollapse: "separate",
  borderSpacing: 0,
  width: "100%",
  maxWidth: "100%",
  position: "relative",
  backgroundColor: theme.palette.white,
  tableLayout: "fixed",
  boxSizing: "border-box",

  "& thead > tr": {
    backgroundColor: theme.palette.bgAlt,
    borderBottom: "1px solid #e5e8eb",
  },

  "& th": {
    padding: "16px 12px",
    fontWeight: 600,
    color: theme.palette.textSecondary,
    textAlign: "left",
    fontSize: 12,
    textTransform: "capitalize",
    letterSpacing: "0.3px",
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",

    "&:first-child": {
      paddingLeft: 20,
      borderTopLeftRadius: 8,
    },

    "&:last-child": {
      paddingRight: 20,
      borderTopRightRadius: 8,
    },

    "@media (max-width: 768px)": {
      padding: "14px 10px",
      fontSize: 11,
      whiteSpace: "normal",

      "&:first-child": {
        paddingLeft: 14,
      },

      "&:last-child": {
        paddingRight: 14,
      },
    },

    "@media (max-width: 460px)": {
      padding: "12px 8px",
      fontSize: 10,
    },
  },

  "& tbody > tr": {
    backgroundColor: theme.palette.white,
    borderBottom: "1px solid #e5e8eb",
    transition: "background-color 0.15s ease",

    "&:last-child": {
      borderBottom: "none",

      "& td:first-child": {
        borderBottomLeftRadius: 8,
      },

      "& td:last-child": {
        borderBottomRightRadius: 8,
      },
    },

    ...(isClickableRow ? ({
      "&:hover": {
        backgroundColor: theme.palette.bgAlt,
        cursor: "pointer",
      }
    }) : {
      "&:hover": {
        backgroundColor: theme.palette.bgAlt,
      }
    }),
  },

  "& td": {
    padding: "16px 12px",
    fontSize: 14,
    color: theme.palette.textPrimary,
    verticalAlign: "top",
    wordBreak: "break-word",
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",

    "&:first-child": {
      paddingLeft: 20,
    },

    "&:last-child": {
      paddingRight: 20,
    },

    "@media (max-width: 768px)": {
      padding: "14px 10px",
      fontSize: 13,

      "&:first-child": {
        paddingLeft: 14,
      },

      "&:last-child": {
        paddingRight: 14,
      },
    },

    "@media (max-width: 460px)": {
      padding: "12px 8px",
      fontSize: 12,
    },
  }
}));

export const PaginationBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 12,
  marginTop: 32,
  padding: "20px 0",
}));

export const PaginationButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  backgroundColor: theme.palette.primaryLight,
  color: theme.palette.white,
  border: "none",
  padding: 0,
  width: 40,
  height: 40,
  borderRadius: 8,
  fontSize: 20,
  cursor: "pointer",
  transition: "all 0.2s ease",
  boxShadow: `0 2px 4px ${theme.palette.shadowSm}`,

  "&:hover:not(:disabled)": {
    backgroundColor: theme.palette.primaryDark,
    transform: "translateY(-1px)",
    boxShadow: `0 4px 8px ${theme.palette.shadowMd}`,
  },

  "&:active:not(:disabled)": {
    transform: "translateY(0)",
    boxShadow: `0 1px 2px ${theme.palette.shadowSm}`,
  },

  "&:disabled": {
    backgroundColor: theme.palette.borderDefault,
    cursor: "not-allowed",
    opacity: 0.6,
  },
}));

export const PageNumberButton = styled("button")(({ theme, active }) => ({
  ...theme.mixins.flexCenterCenter,
  backgroundColor: active ? theme.palette.primaryLight : theme.palette.white,
  color: active ? theme.palette.white : theme.palette.textPrimary,
  border: active ? "none" : `1px solid ${theme.palette.borderLight}`,
  padding: 0,
  width: 40,
  height: 40,
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  transition: "all 0.2s ease",
  boxShadow: active ? `0 2px 4px ${theme.palette.shadowSm}` : "none",

  "&:hover:not(:disabled)": {
    backgroundColor: active ? theme.palette.primaryDark : theme.palette.bgAlt,
    borderColor: active ? "transparent" : theme.palette.borderDefault,
  },

  "&:active:not(:disabled)": {
    transform: "scale(0.95)",
  },

  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.6,
  },
}));

export const PaginationInfo = styled("div")(({ theme }) => ({
  textAlign: "center",
  fontSize: 14,
  color: theme.palette.textSecondary,
  marginTop: 20,
  fontWeight: 500,
}));
